<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import { createEventDispatcher } from "svelte";
  import Button from "../../shared/Button.svelte";
  import Input from "../../shared/Input.svelte";
  import { ArticleType, DatabaseName } from "../../stores/types";
  import type { Entry, Article, DBArticleEntry } from "../../stores/types";
  import moment from "moment";
  import { element } from "svelte/internal";

  export let articleInInventory;

  let dispatch = createEventDispatcher();
  let bestBefore = new Date();
  let lastAdded = moment().format("yyyy-MM-DD");
  let lblArticle = "Artikel";
  let articlePromise = null;

  let addPromise = null;
  const databaseNameInventry = DatabaseName.INVENTORY.toString();
  const databaseNameLogs = DatabaseName.INVENTORYLOG.toString();
  const databaseNameArticle = DatabaseName.ARTICLES.toString();

  let articles = [];
  let articlesNotInInventory = [];

  function articleChangeHandler(items: [DBArticleEntry]) {
    articles = items;
    articlesNotInInventory = filterArticles(articles, articleInInventory);
    articlesNotInInventory.sort(sortArticles);
    console.log(articlesNotInInventory);
  }

  const filterArticles = (articles: DBArticleEntry[], articleInInventory: string[]) => {
    const filteredArticles = articles.filter((el) => {
      return articleInInventory.indexOf(el.item.name) === -1;
    });
    return filteredArticles;
  };

  $: articlePromise = $userbaseStore.openDatabase({
    databaseName: databaseNameArticle,
    changeHandler: articleChangeHandler,
  });

  var sortArticles = function (a: DBArticleEntry, b: DBArticleEntry) {
    var nameA = a.item.name.toUpperCase();
    var nameB = b.item.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  };

  let fields = {
    article: articlesNotInInventory[0],
    amount: 0,
    bestBefore: bestBefore,
    lastAdded: lastAdded,
  };

  const submitHandler = () => {
    // get article from the index
    if (fields.article != undefined) {
      // add new ingredient
      let entry = { ...fields };
      addPromise = $userbaseStore.insertItem({
        databaseName: databaseNameInventry,
        item: entry,
      });
      var logItem = {
        action: "add",
        changedItem: entry,
      };
      addPromise = $userbaseStore.insertItem({
        databaseName: databaseNameLogs,
        item: logItem,
      });
      dispatch("addIngredient");
    } else {
      alert("Artikel auswählen!");
    }
  };
</script>

<form on:submit|preventDefault={submitHandler}>
  <h2>Neuer Eintrag</h2>
  <div class="form-field">
    <label for={lblArticle}
      >{lblArticle}: <br />
      {#if fields.article != undefined} {fields.article.itemId.toString()} {/if}
    </label>
    <select bind:value={fields.article} id={lblArticle}>
      <option value={articles[0]}>Bitte Artikel auswählen....</option>
      {#each articlesNotInInventory as article}
        {#if article != undefined}
          <option value={article}>{article.item.name}</option>
        {/if}
      {/each}
    </select>
  </div>

  <Input label="Menge:" bind:value={fields.amount} type="number" min="10" required />
  <Input label="Mindestens haltbar bis:" bind:value={fields.bestBefore} type="date" required />
  <Input label="gekauft am:" bind:value={fields.lastAdded} type="date" required />
  <Button type="secondary" flat={true}>Neue Zutagen hinzufügen</Button>
</form>

<style>
  select {
    width: 80%;
    border-radius: 6px;
    padding: 10px;
  }
  label {
    width: 80%;
    margin: 10px auto;
    text-align: left;
  }
</style>
